import { cB as e, cNotM as o, cM as i } from "../../../_utils/cssr/index.js";
const t = e("ellipsis", {
  overflow: "hidden"
}, [o("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), i("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), i("cursor-pointer", `
 cursor: pointer;
 `)]);
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/ellipsis/src/styles/index.cssr.js
// module id = 954
// module chunks = 67